// extracted by mini-css-extract-plugin
module.exports = {"embedded-panel-wrapper":"styles_embedded-panel-wrapper__1RH0E","show":"styles_show__2keCJ","header":"styles_header__2ODxt","content":"styles_content__2eZXb"};